import { HIDDEN_BALANCES_FULL_TEXT } from '@/shared/config';
import { cn } from '@/shared/utils';
import { WalletsAssetReserved } from './WalletsAssetReserved';

type Props = {
  isBalancesHidden: boolean;
  valueText: string;
  suffix?: string;
  reservedValue?: number;
  reservedText?: string;
  className?: string;
  valueClassName?: string;
  reservedClassName?: string;
};

const WalletsAssetAmount = ({
  isBalancesHidden,
  valueText,
  suffix,
  reservedValue = 0,
  reservedText,
  className,
  valueClassName,
  reservedClassName,
}: Props) => (
  <div className={cn('flex flex-col items-end gap-[0.2rem]', className)}>
    <span className={cn('headline5 text-primary', valueClassName)}>
      {isBalancesHidden ? HIDDEN_BALANCES_FULL_TEXT : valueText}
      {suffix ? ` ${suffix}` : ''}
    </span>
    {reservedValue > 0 && reservedText && (
      <WalletsAssetReserved
        isBalancesHidden={isBalancesHidden}
        text={reservedText}
        suffix={suffix}
        className={reservedClassName}
      />
    )}
  </div>
);

export { WalletsAssetAmount };
